import { useEffect } from 'react'
import {
  withApplicationNotificationsContext,
  useApplicationNotifications,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import {
  TRANSIENT_MESSAGE_BID_AGAIN,
  TRANSIENT_MESSAGE_TPS_ONLINE_BID_AGAIN,
} from 'common/statics'
import { useListingContext } from 'common/context/listing'

const BidAgainFunctional = () => {
  const { segment, listing } = useListingContext()
  const notifications = useApplicationNotifications()
  const prevSegment = hooks.usePrevious(segment)

  useEffect(() => {
    if (
      segment?.configuration?.should_bid_again &&
      (segment.configuration.bid_again_count ?? 0) >
        (prevSegment?.configuration?.bid_again_count ?? 0)
    ) {
      notifications.overlayBanner.open({
        message:
          listing.listing_configuration?.asset_type ===
          graph.enums.AssetType.Foreclosure
            ? TRANSIENT_MESSAGE_TPS_ONLINE_BID_AGAIN
            : TRANSIENT_MESSAGE_BID_AGAIN,
        title: null,
      })
    }
  }, [segment, notifications, listing])

  return null
}

const BidAgain = withApplicationNotificationsContext(BidAgainFunctional)
export { BidAgain }
export default withApplicationNotificationsContext(BidAgain)
